import { Data, Misc } from '@singularsystems/neo-core';
import { Routing, Views } from '@singularsystems/neo-react';
import { AppService, DomainTypes, Types } from '../../DomainTypes';
import LetterAuthorisationBatchCriteria from '../../Models/LetterAuthorisation/Commands/LetterAuthorisationBatchCriteria';
import LetterAuthorisationBatchLookup from '../../Models/LetterAuthorisation/Lookups/LetterAuthorisationBatchLookup';
import AuthorisationBatchVM from './Components/AuthorisationBatchVM';
import NewAuthorisationBatchVM from './Components/NewAuthorisationBatchVM';
import SignatoriesVM from './Components/SignatoriesVM';

export default class LetterAuthorisationVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        public letterAuthorisationApiClient = AppService.get(DomainTypes.ApiClients.LetterAuthorisation),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService)) {

        super(taskRunner);
        this.makeObservable();

        this.criteriaAutoRunner = this.autoDispose(this.mainCriteria.onAnyPropertyChanged(() => this.mainPageManager.refreshData()));

        this.onBatchRemoved = this.onBatchRemoved.bind(this);
    }

    public signatoriesVM: SignatoriesVM | null = null;
    public newBatchVM: NewAuthorisationBatchVM | null = null;
    public authorisationBatchVM: AuthorisationBatchVM | null = null;
    public isLoadingNewBatch = false;

    public mainCriteria = new LetterAuthorisationBatchCriteria();
    public mainPageManager = new Data.PageManager(this.mainCriteria, LetterAuthorisationBatchLookup, this.letterAuthorisationApiClient.getLetterAuthorisationBatchPaged,
        { fetchInitial: true, pageSize: 50 });

    public criteriaAutoRunner: Misc.IAutoRunner;

    public async initialise() {

    }

    public async handleModeChanged(mode: Routing.IViewParameter, id: Routing.IViewParameter) {
        if (mode.value === "new") {
            this.newBatchVM = this.registerViewModel(new NewAuthorisationBatchVM(this.mainCriteria.clone(), this.taskRunner));
            await this.newBatchVM.initialise();
            mode.description = "New authorisation Batch";
        } else {
            this.closeNewAuthorisationBatch();
        }

        if (mode.value === "signatories") {
            this.signatoriesVM = this.registerViewModel(SignatoriesVM, { initialise: true });
            mode.description = "Manage signatories";
        } else {
            this.closeSignatories();
        }

        if (mode.value === "view" && id.value) {
            this.authorisationBatchVM = this.registerViewModel(new AuthorisationBatchVM(this.taskRunner, this.onBatchRemoved));
            mode.description = "";
            await this.authorisationBatchVM.loadAuthorisationBatch(id.value as number, this.onBatchChanged.bind(this));

            // If the batch was just added, ensure its added to the page manager.
            if (this.isLoadingNewBatch && this.authorisationBatchVM.batch) {
                this.mainPageManager.data.push(this.authorisationBatchVM.batch);
            }

        } else {
            this.closeAuthorisationBatch();
        }
    }

    public closeSignatories() {
        this.disposeViewModel((this as LetterAuthorisationVM).meta.signatoriesVM);
    }

    public closeNewAuthorisationBatch() {
        this.disposeViewModel((this as LetterAuthorisationVM).meta.newBatchVM);
    }

    private onBatchRemoved(batchId: number) {
        this.closeAuthorisationBatch();
        const batch = this.mainPageManager.data.find(c => c.letterAuthorisationBatchId == batchId);
        if (batch) {
            this.mainPageManager.data.removeWithoutTracking(batch);
        }
    }

    public closeAuthorisationBatch() {
        this.disposeViewModel((this as LetterAuthorisationVM).meta.authorisationBatchVM);
    }

    private onBatchChanged() {
        this.mainPageManager.invalidateData();
    }
}